import React from 'react'

function ComingSoon() {
  return (
    <span className="coming-soon-badge">Próximamente</span>
  )
}

export default ComingSoon
